import Label from "@coworker/apprestructured/src/task-management/components/TaskCard/components/Label/Label";
import { Loading } from "@coworker/apprestructured/src/task-management/loading";

type TaskTypeProps = {
  value: string | Loading;
};

function TaskType({ value }: TaskTypeProps) {
  return <Label testId={"task-type"} value={value} />;
}

export default TaskType;
